import { render, staticRenderFns } from "./PeerVideo.vue?vue&type=template&id=182e0422&"
import script from "./PeerVideo.vue?vue&type=script&lang=js&"
export * from "./PeerVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports